import { IOrdersData } from "models/Order";
import { ITableModel } from "../interface";

export interface IOrdersTable {
  trackingKey: string;
  model?: Array<ITableModel>;
  tabFilter?: any;
  filter?: any;
  modelFragment?: Array<ITableModel>;
  DropdownTemplate?: any;
  pageSize?: number;
  showButton?: boolean;
  showFilter?: boolean;
  completeBlankSpaces?: boolean;
  tableSearchClassName?: string;
  searchInputPlaceholder?: string;
  customProps?: {
    [key: string]: any;
  };
  showExportButton?: boolean;
  showDownloadInLotButton?: boolean;
  currentTabId?: {
    name: string;
    order: number;
  };
  showAdvancedFilters?: boolean;
  viewFilters?: ViewFiltersProps;
  showTypeDateFilter?: boolean;
  clearBtn?: boolean;
}

export interface ViewFiltersProps {
  showSituationFilter?: boolean;
  showSchedulingFilter?: boolean;
  showEnterpriseFilter?: boolean;
  showSubsidiaryFilter?: boolean;
}

export interface OrdersDownloadInLotProps {
  data?: Array<IOrdersData>,
  loading: boolean;
}

export interface TableFilterStateOrder {
  startPeriod?: Date;
  lastPeriod?: Date;
  textFilter?: string;
  filterDate?: string;
  status?: string;
  enterpriseCode?: string;
  subsidiary?: string;
  orderType?: number;
  documentNumber?: string;
}

export interface TableFilterStateOrderItems {
  orderItemStatusType?: number;
}

export const groupSituationDelivered = [
  "ENTREGUE",
  "ENTREGUE SL"
];

export const groupSituationNotDelivered = [
  "AGUARDANDO AGENDAMENTO",
  "AGUARDANDO DESPACHO",
  "CHEGOU NO CLIENTE",
  "EM AGENDAMENTO",
  "EM ROTA DE ENTREGA",
  "EM TRÂNSITO ENTRE FILIAIS",
  "ENTRADA DO ORÇAMENTO",
  "FATURAMENTO",
  "LIBERAÇÃO DO FINANCEIRO"
];

export const groupSituationOccurrenceOnDelivery = [
  "OCORRÊNCIA NA ENTREGA",
  "RECUSADO PELO CLIENTE"
];

export const allGroupSituation = [
  "ENTREGUE",
  "ENTREGUE SL",
  "AGUARDANDO AGENDAMENTO",
  "AGUARDANDO DESPACHO",
  "CHEGOU NO CLIENTE",
  "EM AGENDAMENTO",
  "EM ROTA DE ENTREGA",
  "EM TRÂNSITO ENTRE FILIAIS",
  "ENTRADA DO ORÇAMENTO",
  "FATURAMENTO",
  "LIBERAÇÃO DO FINANCEIRO",
  "A CAMINHO - TRANSFERÊNCIA",
  "A CAMINHO - DISTRIBUIÇÃO",
  "OCORRÊNCIA NA ENTREGA",
  "RECUSADO PELO CLIENTE",
];
